export const TableHelpers = {
    data() {
        return {
            tableColumns: [
                // {
                //     title: "#",
                //     type: "text",
                //     key: "rownum",
                // },
                {
                    title: "Ubicación",
                    type: "custom-html",
                    key: "org",
                    modifier: (item) => {
                        return item ? (item.country_id == 1 ? item.canton.name : item.city): "Matriz";
                    },
                },
                {
                    title: "PRODUCTO O MATERIAL A MUESTREAR",
                    type: "custom-html",
                    key: "product",
                    modifier: (value) => {
                        return value;
                    },
                },
                {
                    title: "PROCEDIMIENTO DE MUESTREO (Procedimiento normalizado y procedimiento interno, si aplica)",
                    type: "custom-html",
                    key: "process",
                    modifier: (value) => {
                        return value;
                    },
                },
                {
                    title: 'MÉTODOS DE ENSAYO A LOS QUE APLICA (Procedimiento interno y/o método de referencia con su revisión/edición)',
                    type: "custom-html",
                    key: "method",
                    modifier: (value) => {
                        return value;
                    },
                },
            ],
            actionObj: {
                title: 'Acción',
                type: 'action',
            }
        }
    },
}